/* unplugin-vue-components disabled */import { render } from "./logicNew.vue?vue&type=template&id=0cd19db2&scoped=true"
import script from "./logicNew.vue?vue&type=script&lang=js"
export * from "./logicNew.vue?vue&type=script&lang=js"

import "./logicNew.vue?vue&type=style&index=0&id=0cd19db2&scoped=true&lang=css"
import "./logicNew.vue?vue&type=style&index=1&id=0cd19db2&lang=css"

import exportComponent from "/Users/huangzhichao/Code/beyoung/weitu_land_page_h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd19db2"]])

export default __exports__